import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import HistoryList from "@/components/HistoryList";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Search, FileSpreadsheet, Loader2 } from "lucide-react";

export default function HistoryPage() {
  const [entries, setEntries] = useState(null);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const exportXlsx = async () => {
    setBusy(true);
    try {
      const res = await api.get("/history/xlsx", { responseType: "blob" });
      const m = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/);
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = m ? m[1] : "historico.xlsx"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("No se pudo exportar"); }
    finally { setBusy(false); }
  };

  useEffect(() => {
    api.get("/history").then((r) => setEntries(r.data)).catch(() => setEntries([]));
  }, []);

  if (!entries) return <div className="space-y-3">{[...Array(6)].map((_, i) => <Skeleton key={i} className="h-14" />)}</div>;

  const filtered = entries.filter((h) =>
    (h.employee_name || "").toLowerCase().includes(q.toLowerCase()) ||
    (h.user_email || "").toLowerCase().includes(q.toLowerCase()) ||
    (h.detail || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">Histórico de Cambios</h1>
          <p className="text-muted-foreground text-sm mt-1">Quién modificó qué y cuándo. Trazabilidad para inspecciones.</p>
        </div>
        <div className="flex gap-2 sm:w-auto">
          <div className="relative sm:w-72">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input className="pl-9" placeholder="Buscar empleado, usuario, detalle" value={q}
              onChange={(e) => setQ(e.target.value)} data-testid="history-search" />
          </div>
          <Button variant="outline" onClick={exportXlsx} disabled={busy} data-testid="export-history-button">
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileSpreadsheet className="h-4 w-4 mr-2" />} Exportar Excel
          </Button>
        </div>
      </div>
      <Card className="p-6">
        <HistoryList entries={filtered} showEmployee />
      </Card>
    </div>
  );
}
